// @ts-nocheck
import { SETTINGS_UPDATED } from './actionTypes';
// CUSTOM
// @ts-ignore
import axios from 'axios';
// @ts-ignore
import config from '../../customise/config';
// @ts-ignore
import { FEATURE_CUSTOM_REDUX } from '../../customise/constant';
// @ts-ignore
import { authToken, setLJsonStorage } from '../../customise/welcome-dashboard/Utils';
// @ts-ignore
import { USER_NAME_LEN } from '../../webjam/constant';
const main_url = config.socket_endpoint;
// END
/**
 * Create an action for when the settings are updated.
 *
 * @param {Object} settings - The new (partial) settings properties.
 * @returns {{
 *     type: SETTINGS_UPDATED,
 *     settings: {
 *         audioOutputDeviceId: string,
 *         avatarURL: string,
 *         cameraDeviceId: string,
 *         displayName: string,
 *         email: string,
 *         localFlipX: boolean,
 *         micDeviceId: string,
 *         serverURL: string,
 *         soundsReactions: boolean,
 *         startAudioOnly: boolean,
 *         startWithAudioMuted: boolean,
 *         startWithVideoMuted: boolean,
 *         startWithReactionsMuted: boolean
 *     }
 * }}
 */
export function updateSettings(settings) {
    // CUSTOM
    if (settings.hasOwnProperty("displayName")) {
        try {
            settings.displayName = settings.displayName.substring(0, USER_NAME_LEN);
            if (APP) {
                let { userLoginData, conferenceJoined } = APP.store.getState()[FEATURE_CUSTOM_REDUX];
                setLJsonStorage("auth", {
                    username: settings.displayName
                });
                // if (conferenceJoined) { //  Commented to make it work on pre-meeting screen
                try {
                    let data = {
                        email: userLoginData?.email,
                        username: settings.displayName
                    };
                    let res = axios({
                        method: 'POST',
                        url: main_url + "/profile-update",
                        data,
                        headers: authToken()
                    });
                }
                catch (e) {
                    console.log('profile name error =>', e);
                }
                // }
            }
        }
        catch (e) {
            console.log("user name update error =>", e);
        }
    }
    // END
    return {
        type: SETTINGS_UPDATED,
        settings
    };
}
